import React from 'react'
import PropTypes from 'prop-types'
import Form from 'react-bootstrap/Form'

const propTypes = {
  /**
   * Options containing value and label.
   */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.node.isRequired,
      label: PropTypes.node.isRequired,
      disabled: PropTypes.bool,
      checked: PropTypes.bool,
    }),
  ),
  /**
   * group name radio items
   */
  name: PropTypes.string.isRequired,
  /**
   * Callback for when the radio gets selected
   */
  onSelect: PropTypes.func.isRequired,
  /**
   * Optional class on the option list
   */
  className: PropTypes.string,
}

/**
 * Single select radio list
 * Based on https://react-bootstrap.github.io/forms/checks-radios/.
 *
 * Input ids are scoped with `name` so two groups that share option values (e.g. Adopt as-is)
 * do not collide in the document — duplicate ids make labels toggle the wrong radio.
 */
function RadioSelect(props) {
  const { options = [], name, onSelect, className } = props ?? {}

  return (
    <div className={className}>
      {options.map(({ value, label, disabled, checked }) => (
        <Form.Check
          key={value}
          checked={Boolean(checked)}
          onChange={(event) => onSelect(value, event)}
          type="radio"
          name={name}
          disabled={disabled}
          id={`${name}-${value}`}
          label={label}
        />
      ))}
    </div>
  )
}

RadioSelect.propTypes = propTypes

export default RadioSelect
